import { HttpClient } from '@angular/common/http';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AuthConfigService = /** @class */ (function () {
    function AuthConfigService(_http) {
        this._http = _http;
        this._endpoint = '/odata/Settings/UiPath.Server.Configuration.OData.GetAuthenticationSettings';
    }
    AuthConfigService.prototype.get = function () {
        return this._http.get(this._endpoint)
            .pipe(map(function (data) { return MapperService.authSettingsMapper(data); }));
    };
    AuthConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthConfigService_Factory() { return new AuthConfigService(i0.ɵɵinject(i1.HttpClient)); }, token: AuthConfigService, providedIn: "root" });
    return AuthConfigService;
}());
export { AuthConfigService };
